<template>
  <div class="f-content text-center">
    <span class="f-section-text text-success" v-if="submitted"
      >Jawaban terkirim</span
    >
    <button
      class="o-btn-action"
      ref="button"
      type="button"
      href="#"
      v-on:click.prevent="submit()"
      v-if="!submitted"
    >
      <span>{{ language.submitText }}</span>
    </button>
  </div>
</template>

<script>
import BaseType from "./BaseType.vue";
import { QuestionType } from "../../models/QuestionModel";

export default {
  extends: BaseType,
  name: QuestionType.EndPage,
  props: {
    submitted: {
      type: Boolean
    }
  },
  methods: {
    onEnter() {
      this.dirty = true;

      this._onEnter();
    },

    submit() {
      this.$emit("submit");
    },

    isValid() {
      return true;
    }
  }
};
</script>
